<template>
  <v-card flat color="transparent">
    <v-toolbar flat
      color="transparent">
      <v-toolbar-title v-if="$vuetify.breakpoint.smAndUp" class="body-1">
        <span>{{ `${printProfit} ${printExemptedTax}` }}</span>
      </v-toolbar-title>
      <v-select v-if="!$vuetify.breakpoint.smAndUp" v-model="form.id"
        :label="isEmpty ? '会計がありません' : printLabel"
        :items="getItems"
        item-text="text"
        item-value="value"
        :disabled="isLoading"
        class="mt-4"
        @change="select"
      />
      <div class="flex-grow-1" />
      <v-menu bottom left offset-y>
        <template v-slot:activator="{ on }">
          <v-btn depressed
            v-on="on"
            color="secondary"
            :loading="isLoading">
            <v-icon small class="mr-2">fa-cog</v-icon>{{ $vuetify.breakpoint.smAndUp ? '機能' : '' }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click.stop="$refs.inserter.open()">
            <v-list-item-avatar>
              <v-icon small>fal fa-plus</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>会計を追加する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isSetItem" @click.stop="$refs.titler.open()">
            <v-list-item-avatar>
              <v-icon small>fal fa-pencil</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>会計名を変更する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item v-if="isSetItem" @click.stop="$refs.biller.open()">
            <v-list-item-avatar>
              <v-icon small>fal fa-file-excel</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>請求書を追加する</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isSetItem" @click.stop="$refs.lister.open()">
            <v-list-item-avatar>
              <v-icon small>fal fa-bars</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>請求一覧を開く</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-menu>
      <template v-slot:extension
        v-if="$vuetify.breakpoint.smAndUp && !isEmpty">
        <v-tabs grow
          v-model="store.tabPos"
          background-color="transparent"
          color="secondary">
          <v-tab
            v-for="item in getItems"
            :key="item.value"
            ref="tab"
            :id="`tab_${item.value}`"
            @click="select( { item: { id: item.value } })">{{ item.text }}</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndUp && !isEmpty" class="mb-4"></v-divider>
    <InsertModal ref="inserter" @done="insert" />
    <TitleModal ref="titler" :item="getSelectedItem" @done="insert" />
    <BillModal ref="biller" :item="getSelectedItem" @done="select" />
    <ListModal ref="lister" :item="getSelectedItem" @done="select" />
  </v-card>
</template>
<script>
import InsertModal from './modals/insert'
import TitleModal from './modals/title'
import BillModal from './modals/bill'
import ListModal from './modals/list'
export default {
  name: 'clientCbookToolbar',
  components: {
    InsertModal,
    TitleModal,
    BillModal,
    ListModal
  },
  props: [
    'item'
  ],
  data: () => ({
    config: {
      status: {
        loading: false
      }
    },
    form: {
      id: ''
    },
    store: {
      items: [],
      tabPos: null
    }
  }),
  watch: {
    'store.items.length' (val) {
      this.store.tabPos = val - 1
      this.select({ item: this.store.items[val - 1] })
    }
  },
  mounted () {
    this.get()
  },
  methods: {
    get: function () {
      const { uid } = this.$route.query
      const cid = this.$route.params.id
      this.$set(this.config.status, 'loading', true)
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(`${this.$url.api}cbook/get/items/${cid}`, {}, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', false)
          if (res.data && res.data.success) {
            let items = res.data.data
            let id = (() => {
              if (this.$props.item) {
                return this.$props.item.id
              } else if (uid) {
                return `cbook_${uid.toLowerCase()}`
              } else if (items.length) {
                return items[items.length - 1].id
              } else {
                return ''
              }
            })()
            this.$set(this.store, 'items', items)
            this.select({ item: { id } })
          }
        })
      }).catch(err => {
        console.log(err)
        this.$set(this.config.status, 'loading', false)
      })
    },
    select: function (req) {
      const { item, forceLoad } = req || {}
      const { id } = item || {}
      if (id) {
        this.$set(this.form, 'id', id)
      }
      this.$nextTick(() => {
        let idx = this.store.items.findIndex(it => { return it.id === this.form.id })
        if (idx >= 0) {
          this.$emit('select', {
            type: 'item',
            item: this.store.items[idx],
            forceLoad
          })
          this.store.tabPos = idx 
        } else {
          this.$emit('select', {})
        }
      })
    },
    insert: function (item) {
      let idx = this.store.items.findIndex(it => { return it.id === item.id })
      if (idx >= 0) {
        this.$set(this.store.items[idx], 'title', item.title)
      } else {
        this.store.items.push(item)
      }
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEmpty () {
      return this.store.items.length === 0
    },
    isSetItem () {
      return !!(this.$props.item)
    },
    printProfit () {
      if (this.$props.item) {
        if (this.$props.item.flag === 'T') {
          const { profit } = this.$props.item
          return `【売上】¥${profit}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        } else {
          const { carries, dcpayments, payments, deposites, refunds } = this.$props.item.amounts || {
            carries: {},
            dcpayments: {},
            payments: {},
            deposites: {},
            refunds: {}
          }
          return `【利益】¥${(deposites.sum + refunds.sum - payments.sum - dcpayments.sum + carries.sum)}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        }
      } else {
        return ''
      }
    },
    printExemptedTax () {
      if (this.$props.item) {
        const { charges, payments, dcpayments, deposites } = this.$props.item.amounts || {
          charges: {},
          payments: {},
          dcpayments: {},
          deposites: {}
        }
        return `【非課税】¥${(charges.exempted - payments.exempted - dcpayments.exempted + deposites.exempted)}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return ''
      }
    },
    printLabel () {
      if (this.$props.item) {
        const { item } = this.$props
        return [
          item.title
        ].join(' ')
      } else {
        return '会計一覧'
      }
    },
    getItem () {
      return this.$props.item ? this.$props.item : {}
    },
    getSelectedItem () {
      let idx = this.store.items.findIndex(it => { return it.id === this.form.id })
      return idx >= 0 ? this.store.items[idx] : null
    },
    getItems () {
      return this.store.items.map(it => {
        return {
          text: (it.flag && it.flag === 'T') ? `【確】${it.title}` : it.title,
          value: it.id,
          gtime: it.gtime
        }
      })
    }
  }
}
</script>
